import ThiSensorApi from "../../../api/thi-sensor-api";

// initial state
const initialState = () => ({
  isFetching: false,
  sensors: [],
  sensor: {}
});

// actions
const actions = {
  getSensors: async ({ commit }) => {
    try {
      commit("request");
      const apiResponse = await ThiSensorApi.list();

      if (apiResponse && apiResponse.data) {
        commit("getSensorsSuccess", apiResponse.data);
      } else {
        commit("getSensorsFailed", apiResponse);
      }
    } catch (e) {
      commit("getSensorsFailed", e);
    }
  },

  getSensor: async ({ commit }, payload) => {
    const { thi_sensor_id } = payload || {};
    try {
      commit("request");
      const apiResponse = await ThiSensorApi.get(thi_sensor_id);

      if (apiResponse && apiResponse.data) {
        commit("getSensorSuccess", apiResponse.data);
      } else {
        commit("getSensorFailed", apiResponse);
      }
    } catch (e) {
      commit("getSensorFailed", e);
    }
  },

  clearSensor: ({ commit }) => {
    commit("clearSensor", initialState());
  },

  clear: ({ commit }) => {
    commit("clear", initialState());
  }
};

// mutations
const mutations = {
  request: state => {
    state.isFetching = true;
  },
  getSensorsSuccess: (state, payload = []) => {
    state.isFetching = false;
    state.sensors = payload;
  },
  getSensorsFailed: state => {
    state.isFetching = false;
  },
  getSensorSuccess: (state, payload = {}) => {
    state.isFetching = false;
    state.sensor = payload;
  },
  getSensorFailed: state => {
    state.isFetching = false;
  },
  clearSensor: (state, initialState) => {
    state.sensor = initialState.sensor;
  },
  clear: (state, initialState) => {
    Object.keys(initialState).forEach(key => {
      state[key] = initialState[key];
    });
  }
};

export default {
  namespaced: true,
  state: initialState(),
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/plugins/store/modules/thi-sensors.js